import { render, staticRenderFns } from "./CourierUpsertForm.vue?vue&type=template&id=5253ae9e"
import script from "./CourierUpsertForm.vue?vue&type=script&lang=js"
export * from "./CourierUpsertForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports